import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TASKASSIGNMENT_MY_TASKS } from "./apiRoutes";

export interface TaskAssignment {
  id: string;
  taskName: string;
  school: string;
  role: string;
  priority: string;
  taskStatus: string;
  startDate: string;
  assignTo: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  schoolData?: Array<{ schoolId: string; schoolName: string; status: string }>;
  taskNotes?: Array<{ taskNoteId: string; note: string; createdBy: string; createdAt: string }>;
}

export interface MyTasksResponse {
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  data: Array<{
    records: TaskAssignment[];
    pagination: Array<{ totalRecords: number }>;
  }>;
  message: string;
}

export interface GetMyTasksParams {
  taskName?: string;
  school?: string;
  role?: string;
  priority?: string;
  taskStatus?: string;
  startDate?: string;
  endDate?: string;
  assignTo?: string;
  isActive?: boolean;
  limit?: number;
  page?: number;
  orderBy?: string;
  orderDirection?: string;
}

const fetchMyTaskAssignments = async (params: GetMyTasksParams = {}) => {
  const queryParams = new URLSearchParams();

  if (params.taskName) queryParams.append("taskName", params.taskName);
  if (params.school) queryParams.append("school", params.school);
  if (params.role) queryParams.append("role", params.role);
  if (params.priority) queryParams.append("priority", params.priority);
  if (params.taskStatus) queryParams.append("taskStatus", params.taskStatus);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.assignTo) queryParams.append("assignTo", params.assignTo);
  if (params.limit) queryParams.append("limit", params.limit.toString());
  if (params.page) queryParams.append("page", params.page.toString());
  if (params.orderBy) queryParams.append("orderBy", params.orderBy);
  if (params.orderDirection) queryParams.append("orderDirection", params.orderDirection);
  if (params.endDate) queryParams.append("endDate", params.endDate); // ✅ Added missing one

  const url = queryParams.toString()
    ? `${TASKASSIGNMENT_MY_TASKS}?${queryParams.toString()}`
    : TASKASSIGNMENT_MY_TASKS;

  const response = await axiosAuth.get<MyTasksResponse>(url);
  return response.data;
};


export const useGetMyTasksQuery = (
  params: GetMyTasksParams = {},
  options?: UseQueryOptions<MyTasksResponse, Error>
) => {
  return useQuery({
    queryKey: ["taskAssignments", params],
    queryFn: () => fetchMyTaskAssignments(params),
    ...options,
  });
};